import React, { useLayoutEffect } from 'react'
import { Snackbar } from '@material-ui/core'
import {
  ErrorOutline,
  CheckCircleOutlineOutlined,
  WarningOutlined,
  InfoOutlined
} from '@material-ui/icons'
import Routes from 'routes'
import { useSelector, useDispatch } from 'react-redux'
import { closeSnackbar, windowResize } from 'utils/common/actions'
import CookiesSnackbar from 'components/CookiesSnackbar'


function snackbarIcon(type) {
  switch (type) {
    case 'error':
      return <ErrorOutline />
    case 'warning':
      return <WarningOutlined />
    case 'info':
      return <InfoOutlined />
    default:
      return <CheckCircleOutlineOutlined />
  }
}

const App = () => {
  const dispatch = useDispatch()
  const authToken = useSelector(state => state.auth.authToken)
  const userType = useSelector(state => state.auth.userType)
  const activeWorkspace = useSelector(state => state.auth.activeWorkspace)
  const snackbarMessage = useSelector(state => state.common.snackbarMessage)
  const snackbarType = useSelector(state => state.common.snackbarType)
  const cookiesSnack = useSelector(state => state.common.cookiesSnack)

  useLayoutEffect(() => {
    function updateSize() {
      dispatch(windowResize())
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='app-wrapper'>
        <Routes authToken={authToken} userType={userType} activeWorkspace={activeWorkspace} />
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!snackbarMessage}
        onClose={() => dispatch(closeSnackbar())}
      >
        <div className={`snackbar-box ${snackbarType}`}>
          {snackbarIcon(snackbarType)} {snackbarMessage}
        </div>
      </Snackbar>
      <CookiesSnackbar
        open={!cookiesSnack}
      />
    </>
  )
}


export default App
